import { Z_INDEX_OVERLAY_MEDIUM } from '../../constants/z_index';
import { ArrowContainer } from '../../nav-ui-components/ArrowContainer';
import { css } from 'foundations-theming-specialty/utils';
import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const containerStyles = theme => css(["border-radius:3px;color:", ";background-color:", ";line-height:1.5;max-width:205px;padding:10px 16px;font-size:13px;z-index:", ";"], theme.color['global-shell-text-nav-item-selected'], theme.color['global-shell-fill-surface-panel-default'], Z_INDEX_OVERLAY_MEDIUM);
const arrowStyles = theme => css(["background:", ";"], theme.color['global-shell-fill-surface-panel-default']);
const BookmarksTooltip = ({
  text
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ArrowContainer, {
    id: "bookmark-tooltip-content",
    arrowPosition: "left",
    arrowSize: 8,
    containerStyles: containerStyles(theme),
    arrowStyles: arrowStyles(theme),
    children: text
  });
};
export default BookmarksTooltip;